import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetSingleSchool = async (SchoolID) => {
  try {
    const SchoolCollection = await collection(db, "Schools");
    const SchoolDocument = await doc(SchoolCollection, SchoolID);
    const SchoolSnapshot = await getDoc(
      SchoolDocument,
      where("IsDeleted", "==", false)
    );

    let School = { ...SchoolSnapshot.data(), id: SchoolSnapshot.id };

    return School;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleSchool;
